import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,[(_vm.allowed && !_vm.emailVerificationRequired)?_c(_vm.layout,{tag:"component"},[_c('router-view')],1):(_vm.emailVerificationRequired)?_c('EmailVerification'):_c(VProgressLinear,{attrs:{"color":"vct-blue","indeterminate":""}}),_c(VSnackbar,{attrs:{"value":_vm.snackbar,"color":_vm.snackbarColor,"multi-line":true,"timeout":_vm.snackbarTimeout}},[_vm._v(" "+_vm._s(_vm.snackbarText)+" "),_c(VBtn,{attrs:{"text":""},on:{"click":_vm.closeSnackbar}},[_vm._v(" Close ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }